import { render, staticRenderFns } from "./MemberFeebackComponent.vue?vue&type=template&id=ab35b9de&scoped=true&"
import script from "./MemberFeebackComponent.vue?vue&type=script&lang=js&"
export * from "./MemberFeebackComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberFeebackComponent.vue?vue&type=style&index=0&id=ab35b9de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab35b9de",
  null
  
)

export default component.exports